import CoachArticlesQuery from './coach-articles.query'

export default CoachArticlesQuery
